<template>
    <div id="main-page">
        <SOSlotBase :bg-grey="false">
            <template v-slot:title-bar>
                <SOTitleBar :type="'back'" page-title="Buat Penjadwalan Otomatis" @back="$router.go(-1)" />
            </template>
            <template v-slot:content>
                <div>
                    <div class="p-x-20 p-t-8">
                        <SearchKonsumen
                            :val="id ? form.customer.nama : null"
                            :disableInput="id !== null"
                            @selected="(v) => setKonsumen(v)"
                        />
                    </div>
                    <div class="separator mt-4"/>
                    <template v-if="form.idcustomer">
                        <div class="p-x-20 p-t-8">
                            <div class="mb-2">
                                <SOInputSelect
                                    title="Pilih Outlet"
                                    :required="true"
                                    placeholder="Sena Laundry"
                                    :options="listOutlet"
                                    @option-selected="(v) => (form.idoutlet = v)"
                                    :selected="form.idoutlet"
                                    :disabled="id !== null"
                                />
                            </div>
                            <SOInputDateTime
                                title="Waktu awal transaksi yang akan ditagih"
                                id="awal-transaksi"
                                :placeholder="$moment().format('YYYY-MM-DD, HH:mm')"
                                :value="id == null ? $moment().format('YYYY-MM-DD') + 'T' + $moment().format('HH:mm') : $moment(form.periode_awal).format('YYYY-MM-DD') + 'T' + $moment().format('HH:mm')"
                                :required="true"
                                :disabled="id !== null"
                                @get-date="
                                    (v) => form.periode_awal = v"
                            />
                            <p class="f-c-midgrey f-12">
                                Digunakan sebagai acuan, saat jadwal pertama kali dijalankan, selanjutnya akan menggunakan tanggal terakhir ditagih.
                            </p>
                            <!-- <ErrorMessage class="error" label="Jatuh Tempo Invoice" :validation="$v.post.jatuhTempo" /> -->
                            <div id="jam-cron" class="mb-2">
                                <SOInputTime
                                    title="Jam run cron"
                                    id="schedule-posting-time"
                                    placeholder="00:00"
                                    :value="form.custom_time"
                                    @get-time="(v) => form.custom_time = v"
                                />
                            </div>
                            <div class="mb-2">
                                <SOInputSelect
                                    title="Ulangi setiap"
                                    :required="true"
                                    placeholder="Pilih Pengulangan"
                                    :options="[
                                            {
                                                id: 'monthly',
                                                text: 'Bulanan',
                                            },
                                            {
                                                id: 'weekly',
                                                text: 'Mingguan',
                                            }
                                        ]"
                                    :selected="form.jenis_periode"
                                    @option-selected="(v) => changePengulangan(v)"
                                />
                            </div>
                            <SOInputSelect
                                v-if="form.jenis_periode == 'monthly'"
                                title="Tanggal"
                                :required="true"
                                placeholder="Pilih Tanggal 1-27, Akhir Bulan"
                                :options="listTanggal"
                                :selected="form.waktu"
                                @option-selected="(v) => form.waktu = v"
                            />
                            <SOInputSelect
                                v-if="form.jenis_periode == 'weekly'"
                                title="Hari"
                                :required="true"
                                placeholder="Senin-Minggu"
                                :options="listHari"
                                :selected="form.waktu"
                                @option-selected="(v) => (form.waktu = v)"
                            />
                            <div class="mt-2">
                                <SOInputSelect
                                    title=" Karyawan Penanggung Jawab"
                                    :required="true"
                                    placeholder="Pilih Karyawan"
                                    :options="listKaryawan"
                                    :selected="form.idkaryawan"
                                    @option-selected="(v) => (form.idkaryawan = v)"
                                />
                            </div>
                        </div>
                        <div class="separator mt-4"/>
                        <div class="p-x-20 p-t-8">
                            <div
                                @click="form.kirim_wa_customer = !form.kirim_wa_customer"
                                class="d-flex my-2"
                            >
                                <SOCheckBox :is-checked="form.kirim_wa_customer" />
                                <div class="ml-2">
                                    <span>
                                        Otomatis Kirim Invoice Ke Whatsapp {{ id == null ? konsumen.nama : form.customer.nama }} - 
                                    </span>
                                    <span class="f-bold">
                                        {{ id == null ? konsumen.telp : form.customer.telp }}
                                    </span>
                                </div>
                            </div>
                            <template v-if="form.kirim_wa_customer">
                                <div class="form-group mod border p-2 rounded" v-if="form.kirim_wa_customer">
                                    <div class="d-flex px-2 p-2" style="gap: 7px; flex-flow: wrap" v-if="form.other_telp.length">
                                        <div
                                            @click="removePhone(index)"
                                            class="d-flex align-items-baseline rounded bg-gray pt-1 px-1"
                                            style="gap: 10px; border: 2px solid #C8D0DD;"
                                            v-for="(n, index) in form.other_telp"
                                            :key="index"
                                        >
                                            <span>
                                                {{ n }}
                                            </span>
                                            <SOIconBase  view-box="0 0 12 12" width="14" height="14">
                                                <template v-slot:icon>
                                                    <CloseX1212 iconFill="#6F7287" />
                                                </template>
                                            </SOIconBase>
                                        </div>
                                    </div>
                                    <div>
                                        <input
                                            v-model="otherPhone"
                                            type="tel"
                                            placeholder="Ketuk untuk menambah...."
                                            class="form-control border-0"
                                            @keyup.enter="() => addPhone()"
                                        >
                                        <!-- <SOInputTelp
                                            id="input-wa"
                                            title="Nomor Whatsapp"
                                            :required="true"
                                            countryCode="62"
                                            placeholder="8123456789"
                                            :value="getNotelp"
                                            @input="onInput($event, 'nomor')"
                                            @country-code="onInput($event, 'country_code')"
                                        /> -->
                                    </div>
                                </div>
                                <p class="f-12 f-c-midgrey">Maks 3 Nomor, Pastikan penerima diatas sudah terdaftar WA</p>
                            </template>
                        </div>
                        <div class="border border-bottom mt-2" />
                    </template>
                </div>
            </template>
        </SOSlotBase>
        <div class="btn_action_wrapper">
            <div id="" class="p-2 f-12 border-top bg-white">
                <div>
                    <div class="text-center f-c-midgrey" v-if="Mcoin.value == 2500">
                        <span class="f-semi">Biaya Jadwal Otomatis: 2500</span>
                        <span>M-coin/Dijalankan</span>
                    </div>
                    <div class="text-center f-c-midgrey" v-if="Mcoin.value == 0">
                        <span class="f-semi">Biaya Jadwal Otomatis: <span style="text-decoration: line-through;">2500 M-coin/Dijalankan</span></span>
                        <span class="f-c-red"> Gratis</span>
                    </div>
                </div>
                <SOButton
                    :primary="true"
                    :full="true"
                    :disable="!isValid || pageSetting.isLoading"
                    :loading="pageSetting.isLoading"
                    :text="'Buat Penjadwalan Otomatis'"
                    :id="`btn_act_tolak_settlement`"
                    @action="submit()"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint.js";
import SearchKonsumen from '../components/SearchKonsumen.vue'
import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import CloseX1212 from "@/so-components/global/icons/iconPacks/CloseX1212.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import ErrorMessage from "@/component-items/ErrorMessage";
import SOInputDateTime from "@/so-components/global/input/SOInputDateTime.vue";
import SOCheckBox from "@/so-components/global/ui/SOCheckBox";
import SOInputRegular from "@/so-components/global/input/SOInputRegular.vue";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputTime from "@/so-components/global/input/SOInputTime.vue";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

export default {
    name: 'penjadwalanCreate',
    components: {
        SOSlotBase,
        SOTitleBar,
        SOInputSelect,
        ErrorMessage,
        SOInputDateTime,
        SOCheckBox,
        SOIconBase,
        CloseX1212,
        SOInputRegular,
        SearchKonsumen,
        SOButton,
        SOInputTime,
        SOLoadingPage,
    },
    props: {
        id: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isLoading:false,
            pageSetting: {
                isLoading: false
            },
            listOutlet: [],
            form: {
                idcustomer: null,
                periode_awal: null,
                jenis_periode: null,
                waktu: null,
                idoutlet: null,
                kirim_wa_customer: true,
                other_telp: [],
                idkaryawan: null,
                custom_time: null,
            },
            konsumen: {},
            otherPhone: null,
            Mcoin: {},
        }
    },
    mounted() {
        this.init()
        this.getMcoinInfo()
        this.smartTrackingView('add_penjadwalan_otomatis')

    },
    computed: {
        ...mapGetters({
            data: `invoiceModule/penjadwalanDetail`,
        }),
        isValid() {
            if (this.form.idcustomer && this.form.periode_awal && this.form.idoutlet && this.form.idkaryawan && this.form.jenis_periode && this.form.waktu) {
                return true
            }
            else {
                return false
            }
        },
        listKaryawan() {
            let list = this.$store.state.metaModule.karyawanAll
            return list.map(v => {
                return {
                    ...list,
                    id: v.idkaryawan,
                    text: v.nama
                }
            })
        },
        listTanggal() {
            const tanggal = [
                {
                    id: 31,
                    text: 'Akhir Bulan'
                }
            ]
            for (let index = 1; index <= 27; index++) {
                tanggal.push({
                    id: index,
                    text: index
                })
            }
            return tanggal
        },
        listHari() {
            const hari = ['Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu', 'Minggu']
            return hari.map((value, index) => {
                return {
                    id: index + 1,
                    text: value
                }
            });
        },
        
    },
    methods: {
        ...mapActions({
            createPenjadwalan: `invoiceModule/createPenjadwalan`,
            getDetailPenjadwalan: `invoiceModule/getDetailPenjadwalan`,
            updatePenjadwalan: `invoiceModule/updatePenjadwalan`,
        }),
        async submit() {
            this.smartTrackingClick('simpan_penjadwalan_otomatis')

            this.pageSetting.isLoading = true
            const post = {
                ...this.form,
                waktu: parseInt(this.form.waktu),
                kirim_wa_customer: parseInt(this.form.kirim_wa_customer),
                periode_awal: this.$moment(this.form.periode_awal).format("DD/MM/YYYY hh:mm"),
                kirim_wa_customer: this.form.kirim_wa_customer ? 1 : 0
            }
            try {
                const res = this.id ? await this.updatePenjadwalan(post) : await this.createPenjadwalan(post)
                console.log(res);
                this.pageSetting.isLoading = false
                if (res.success) {
                    this.$toast.success(`Berhasil ${this.id ? 'mengubah' : 'membuat' } penjadwalan otomatis`);
                    this.$router.back();
                }
                else {
                    this.$toast.error(res.err)
                }
            } catch (e) {
                this.pageSetting.isLoading = false
                this.$toast.error(e)
            }
        },
        defaultForm() {
            return {
                idcustomer: null,
                periode_awal: null,
                jenis_periode: null,
                waktu: null,
                idoutlet: null,
                kirim_wa_customer: true,
                other_telp: [],
                idkaryawan: null,
                custom_time: null,
            }
        },
        setKonsumen(item) {
            this.konsumen = item
            if (this.konsumen.hasOwnProperty('idcustomer')) {
                this.form.idoutlet = this.konsumen.idoutlet || this.listOutlet[0].id
                this.form.idcustomer = this.konsumen.idcustomer
            } else {
                this.form = this.defaultForm()
            }            
        },
        addPhone() {
            if (this.form.other_telp.length > 2) {
                this.$toast.warning('Maksimal 3 Nomor')
                return
            }
            this.form.other_telp.push(this.otherPhone)
            this.otherPhone = null
        },
        removePhone(index) {
            console.log(index)
            const other_telp = this.form.other_telp.splice(index, 1)
            console.log(other_telp);
        },
        async getMcoinInfo(){
            try {
                const res = await conn.get(api.getMcoinInfo);
                if (!this.Mcoin.length) {
                        this.Mcoin = res.data.data
                    }
                    else {
                        res.data.data.forEach(element => {
                            this.Mcoin.push(element);
                        });
                    }
            } catch (e) {
                console.log(error);
                this.isLoading = false;
                return resulter.errorResult(e)
            }
        },
        async init() {
            this.isLoading = true
            if (this.id) {
                await this.getDetailPenjadwalan(this.id) 
                const data = this.data.masal_cron
                const other_telp = data.other_telp ? data.other_telp.split(';') : []
                this.form = {
                    ...this.data.masal_cron,
                    kirim_wa_customer: data.kirim_wa_customer == "1" ? true : false,
                    other_telp: other_telp,
                    custom_time: data.custom_time,
                }

            }
            this.getOutlet();
            await this.getListKaryawan();
            this.isLoading = false
        },
        async getOutlet() {
            try {
                const res = await this.$store.dispatch("outletModule/fetchOutletAll");
                this.listOutlet = res.data.map(value => {
                    return {
                        telp: value.telp,
                        id: value.idoutlet,
                        text: value.nama
                    }
                });
            } catch (error) {
                this.$toas.error(error)
            }
        },
        async getListKaryawan() {
            const res = await this.$store.dispatch("metaModule/fetchKaryawanAll");
            if (res.success) {
                
            }
        },
        changePengulangan(v) {
            this.form.jenis_periode = v
            this.form.waktu = null
            console.log(this.form);
        }
    }
}
</script>   

<style scoped>
#jam-cron {
    display: none;
}
#btn-container {
    position: fixed;
    width: 100%;
    bottom: 64px;
}
</style>